var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.833a1.242 1.242 0 00-.834 2.175v1.159a.833.833 0 001.667 0v-1.159A1.242 1.242 0 007 9.833zM11.166 6.5V4.833a4.166 4.166 0 10-8.333 0V6.5A2.5 2.5 0 00.333 9v5.833a2.5 2.5 0 002.5 2.5h8.333a2.5 2.5 0 002.5-2.5V9a2.5 2.5 0 00-2.5-2.5zM4.5 4.833a2.5 2.5 0 015 0V6.5h-5V4.833zm7.5 10a.833.833 0 01-.834.833H2.833A.833.833 0 012 14.833V9a.833.833 0 01.833-.834h8.333A.833.833 0 0112 9v5.833z",
    fill: "#8A9AA7"
  })));
}
export default SvgLock;